import React from "react";

import { compose } from 'recompose'
import { connect } from 'react-redux'
import { getTranslate } from "react-localize-redux";

import { getShipmentPrice } from 'actions/payment'

import NumberFormat from 'react-number-format';

// material-ui components
import withStyles from "material-ui/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";

import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  inputAdornmentIcon: {
    color: "#555"
  },
  choiche: {
    textAlign: "center",
    cursor: "pointer",
    marginTop: "20px"
  },
  ...customSelectStyle,
  ...customCheckboxRadioSwitch
};

class Step4 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      price: 10,
    };
    this.refreshPrice = this.refreshPrice.bind(this);
  }
  
  change = event => {
    this.setState({ [event.target.name]: event.target.value });
    this.props.change({ [event.target.name]: event.target.value });
  };

  refreshPrice(){
    this.props.dispatchGetShipmentPrice(this.props.auth.user, this.props.fullState)
    .then( data => {
      this.setState({price: data.price});
    });  
  }

  componentDidMount() {
    this.refreshPrice();
  }


  render() {

    const { classes, fullState } = this.props;
    const { price } = this.state;

    return (
      <div>
        <h4 className={classes.infoText}>Please review</h4>
        <GridContainer justify="center">
          <ItemGrid xs={12} sm={12} md={8}>

          {Object.keys(fullState).map( (prop, key)=>{
            return (
            <GridContainer justify="center" key={key}>
              <ItemGrid xs={12} sm={12} md={6}>{prop}</ItemGrid>
              <ItemGrid xs={12} sm={12} md={6}>{fullState[prop]}</ItemGrid>
            </GridContainer>);
          })}

          <GridContainer justify="center">
            <ItemGrid xs={12} sm={12} md={6}>Cost</ItemGrid>
            <ItemGrid xs={12} sm={12} md={6}>
              <NumberFormat value={price} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
            </ItemGrid>
            <ItemGrid xs={12} sm={12} md={12}>Your card will be charged.</ItemGrid>
          </GridContainer>


          </ItemGrid>     
        </GridContainer>
      </div>
    );
  }
}


const mapDispatchToProps = {
  dispatchGetShipmentPrice: (user, data) => getShipmentPrice(user, data),
}

const mapStateToProps = (state, props) => {
  return {
    translate: getTranslate(state.localize),
    auth: state.auth,
    userDetails: state.user.userDetails,
  }
}


export default compose(
  withStyles(style),
  connect(mapStateToProps, mapDispatchToProps)
)(Step4);






// WEBPACK FOOTER //
// ./src/views/Customer/AddShipmentWizardSteps/Step4.jsx